import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Page error:', error, info);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div
          style={{
            padding: '2rem',
            maxWidth: 560,
            margin: '2rem auto',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: 12,
            color: '#991b1b'
          }}
        >
          <h2 style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Something went wrong</h2>
          <pre style={{ fontSize: '0.75rem', whiteSpace: 'pre-wrap', marginBottom: '1rem' }}>
            {error.message}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '0.4rem 0.75rem',
              borderRadius: 8,
              border: '1px solid #fca5a5',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
